import { createFileRoute } from "@tanstack/react-router";
import { CABINET_HOME_COPY } from "@/components/partners/cabinet-home-copy";
import { tutorCabinetHead } from "@/components/partners/tutor-cabinet-head";
import { TutorJoinSentPage } from "@/components/partners/TutorJoinSentPage";

// Экран «Готово!» после анкеты (en). «_» после join — не вкладывать в страницу
// формы: у неё нет <Outlet/>. noindex, в sitemap нет.
export const Route = createFileRoute("/en/tutors/join_/sent")({
  head: () => tutorCabinetHead("en", CABINET_HOME_COPY.en.sentH1),
  component: () => <TutorJoinSentPage lang="en" />,
});
